import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { AccessRightState, initialAccessRightState, WorkListDataState, WorkListState } from './types';
import { workListDataSaga } from './saga';
import { biType } from '../../../../locales/types';
import { apiList } from '../../../../locales/apiList';
import { UseAxios } from '../../../../utils/UseAxios';
import { worklistFilter } from './types';
import moment from 'moment';

export const initialState: WorkListState = {
  searhList: null,
  contractStatus: null,
  selectedPreviewSection: biType.RECURRING,
  username: '',
  userEmail: '',
  dept: '',
  accessRight: initialAccessRightState,
  errorDialog: false,
  errorWordings: '',
  leftMenuOpen: false,
  historyDate: '',
  lastFilter: { allPending: true },
  loading: false,
};

export const fetchWorkList = createAsyncThunk(
  'workListState/fetchWorkList',
  async (filter: any, { rejectWithValue, getState }) => {
    const state = getState() as { workListState?: { lastFilter?: worklistFilter } };
    const lastFilter = state.workListState?.lastFilter || { contractType: ['New', 'Renew'] };
    const usedFilter = filter && Object.keys(filter).length > 0 ? filter : lastFilter;
    let filterString = '?';
    if (usedFilter.contractType && usedFilter.contractType.length > 0) {
      filterString += `contractType=${usedFilter.contractType.join(',')}&`;
    }
    if (usedFilter.contractNumber) {
      filterString += `contractNumber=${usedFilter.contractNumber.toUpperCase().replace('OA-CL-', '')}&`;
    }
    if (usedFilter.customerCode !== '') {
      filterString += `customerCode=${usedFilter.customerCode}&`;
    }
    if (usedFilter.remark) {
      filterString += `remark=${usedFilter.remark}&`;
    }
    if (usedFilter.allPending) {
      filterString += `allPending=${usedFilter.allPending}&`;
    } else if (usedFilter.selctedSection && usedFilter.selectedStatus) {
      filterString += `${usedFilter.selctedSection}Status=${usedFilter.selectedStatus}&`;
    }
    if (usedFilter.selectedBISubmittedDateFrom) {
      filterString += `biSubmittedDateFrom=${moment(usedFilter.selectedBISubmittedDateFrom).startOf('day').utc().toISOString()}&`;
    }
    if (usedFilter.selectedBISubmittedDateTo) {
      filterString += `biSubmittedDateTo=${moment(usedFilter.selectedBISubmittedDateTo).endOf('day').utc().toISOString()}&`;
    }
    filterString = filterString === '?' ? '' : filterString.slice(0, -1);
    const requestURL = `${apiList.getWorklistURL}${filterString}`;
    try {
      const result = await UseAxios(requestURL, 'get');
      if (result.data) {
        return { data: result.data, usedFilter };
      } else {
        return rejectWithValue(result.error || 'Unknown error');
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const slice = createSlice({
  name: 'workListState',
  initialState,
  reducers: {
    // getWorkList() {
    // state.error = null;
    // },
    reposLoaded(state, action: PayloadAction<WorkListDataState[]>) {
      state.searhList = action.payload;
    },
    updateContractStatus(state, action: PayloadAction<WorkListDataState | any>) {
      state.contractStatus = action.payload;
    },
    updateSelectedPreviewSection(state, action: PayloadAction<biType>) {
      state.selectedPreviewSection = action.payload;
    },
    updateUsername(state, action: PayloadAction<string>) {
      state.username = action.payload;
    },
    updateUserEmail(state, action: PayloadAction<string>) {
      state.userEmail = action.payload;
    },
    updateErrorDialog(state, action: PayloadAction<boolean>) {
      state.errorDialog = action.payload;
    },
    updateErrorWordings(state, action: PayloadAction<string>) {
      state.errorWordings = action.payload;
    },
    updateDept(state, action: PayloadAction<string>) {
      state.dept = action.payload;
    },
    updateAccessRight(state, action: PayloadAction<AccessRightState>) {
      state.accessRight = action.payload;
    },
    updateLeftMenuOpen(state, action: PayloadAction<boolean>) {
      state.leftMenuOpen = action.payload;
    },
    updateHistoryDate(state, action: PayloadAction<string>) {
      state.historyDate = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchWorkList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkList.fulfilled, (state, action) => {
        if (action.payload && action.payload.data) {
          state.searhList = action.payload.data;
          state.lastFilter = action.payload.usedFilter;
        }
        state.loading = false;
      })
      .addCase(fetchWorkList.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { actions: workListDataActions, reducer } = slice;

export const useWorkListDataSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: workListDataSaga });
  return { actions: slice.actions };
};

export const useWorkListStateSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  return { actions: slice.actions };
};